import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { createUseStyles } from 'react-jss';

import { Spacings } from '@picsart/design-system/foundation/spacings';
import { FontWeights } from '@picsart/design-system/foundation/fonts';

const useStyles = createUseStyles(
  {
    root: {
      marginBottom: Spacings.s64,
    },
    title: {
      fontSize: FontSizes.s30,
      fontWeight: FontWeights.semibold,
      lineHeight: LineHeights.l36,
      marginBottom: Spacings.s8,
      textAlign: 'center',
      '& > h2': {
        lineHeight: LineHeights.l36,
      },
      '& p': {
        display: 'inline',
      },
    },
    description: {
      fontSize: FontSizes.s16,
      fontWeight: FontWeights.medium,
      lineHeight: LineHeights.l24,
      marginBottom: Spacings.s12,
      display: 'flex',
      alignItems: 'center',
      gap: Spacings.s6,
      maxWidth: 712,
      textAlign: 'center',
      justifyContent: 'center',
      '& p': {
        display: 'inline',
      },
      '& > div': {
        fontSize: FontSizes.s16,
      },
      '@media screen and (max-width: 768px)': {
        textAlign: 'center',
        display: 'inline-block',
        fontSize: FontSizes.s16,
        '& p': {
          fontSize: FontSizes.s16,
        },
      },
    },

    bannerContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: [Spacings.s0, Spacings.s24],
      fontSize: FontSizes.s30,
      '@media screen and (max-width: 768px)': {
        padding: [Spacings.s0, Spacings.s12],
      },
      '& > div': {
        maxWidth: 712,
        width: '100%',
        marginBottom: Spacings.s16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: Spacings.s6,
        '@media screen and (max-width: 768px)': {
          marginBottom: Spacings.s16,
        },
      },
      '& h2': {
        fontSize: FontSizes.s30,
      },
    },
  },
  {
    name: 'top-banenr',
  },
);

export default useStyles;
